import React from "react";
import ClientLogo from "./ClientLogo";

interface ClientHeaderProps {
  clientLogoURL?: string;
  clientName?: string;
  className?: string;
}

const ClientHeader: React.FC<ClientHeaderProps> = ({ clientLogoURL, clientName, className }) => {
  const hasContent = clientLogoURL || clientName;
  if (!hasContent) return null;

  return (
    <div className={`flex flex-col items-start gap-2 mb-2 ${className ?? ""}`}>
      <ClientHeaderLogo src={clientLogoURL} alt={clientName} />
      <ClientHeaderName name={clientName} />
    </div>
  );
};

const ClientHeaderLogo: React.FC<{ src?: string; alt?: string }> = ({ src, alt }) => {
  if (!src) return null;
  return <ClientLogo src={src} alt={alt} />;
};

const ClientHeaderName: React.FC<{ name?: string }> = ({ name }) => {
  if (!name) return null;
  return (
    <p className="text-[13px] text-(--text-secondary) tracking-wide">
      {name}
    </p>
  );
};

export default ClientHeader;
